// src/components/HeroBanner.js
import React from "react";

export function HeroBanner() {
  return (
    <div className="hero-banner">
      <div className="hero-inner">
        <div className="hero-eyebrow">
          <span className="hero-eyebrow-line" aria-hidden="true" />
          <span className="hero-eyebrow-text">NIIT Enterprise Tech Learning Solutions</span>
        </div>
        <h1 className="hero-title">Solutions Hub</h1>
        <p className="hero-subtitle">
          Search and download curated programme materials across all practices.
          Use the filters below to find exactly what you need.
        </p>
      </div>
    </div>
  );
}
